import { typedBoolean } from "~/utils/typing";

/**
 * Searches for a term in an array of objects based on the given query.
 *
 * @template T - The type of objects in the array.
 * @param {string | null | undefined} query - The search query.
 * @param {(t: T) => string[]} getTerms - A function that returns an array of terms for an object.
 *
 * @returns {(t: T) => boolean} - A function that takes an object and returns true if any of its terms match the query, or true if no query is provided.
 */
export const search =
  <T>(query: string | null | undefined, getTerms: (t: T) => string[]) =>
  (t: T) =>
    !query
      ? true
      : getTerms(t)
          .filter(typedBoolean)
          .some((it) => it.toLowerCase().includes(query.toLowerCase()));
